import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const AiRouterSettingsModal = ({ open, onClose }) => {
  const [enabled, setEnabled] = useState(false);
  const [apiKey, setApiKey] = useState("");
  const [model, setModel] = useState("gpt-3.5-turbo-1106");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/ai-router-settings");
        setEnabled(!!data.enabled);
        setApiKey(data.apiKey || "");
        setModel(data.model || "gpt-3.5-turbo-1106");
      } catch (err) {
        toastError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [open]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put("/ai-router-settings", { enabled, apiKey, model });
      toast.success("Configurações salvas!");
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Roteador de fila por IA</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
              Quando ativado, a primeira mensagem de um atendimento novo (ainda sem fila) é
              analisada por IA e movida direto pra fila mais provável, com base na descrição
              que você preencher em cada fila (aba "Filas"). Só uma chave/modelo aqui, separado
              do que já existe em outras integrações.
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={enabled}
                  onChange={(e) => setEnabled(e.target.checked)}
                />
              }
              label={enabled ? "Ativado" : "Desativado"}
            />
            <TextField
              label="Chave de API (da mesma empresa do modelo escolhido acima)"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              fullWidth
              variant="outlined"
              margin="dense"
              placeholder="sk-..."
            />
            <TextField
              select
              label="Modelo"
              value={model}
              onChange={(e) => setModel(e.target.value)}
              fullWidth
              variant="outlined"
              margin="dense"
            >
              <MenuItem value="gpt-3.5-turbo-1106">gpt-3.5-turbo-1106 (OpenAI, mais barato)</MenuItem>
              <MenuItem value="gpt-4o">gpt-4o (OpenAI, mais preciso)</MenuItem>
              <MenuItem value="gemini-2.0-flash">gemini-2.0-flash (Google, mais barato)</MenuItem>
              <MenuItem value="gemini-2.0-pro">gemini-2.0-pro (Google, mais preciso)</MenuItem>
              <MenuItem value="claude-haiku-4-5-20251001">claude-haiku-4.5 (Anthropic, mais barato)</MenuItem>
              <MenuItem value="claude-sonnet-5">claude-sonnet-5 (Anthropic, mais preciso)</MenuItem>
            </TextField>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={saving}>
          Cancelar
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained" disabled={saving || loading}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AiRouterSettingsModal;
